export default __webpack_public_path__ + "static/media/SUPERIOR STRAPED.234fa4d4.jpg";